(function() {
  "use strict";

  angular
    .module("admin.challenges.service", [])
    .factory("ChallengesService", ChallengesService);

  /** @ngInject */
  function ChallengesService($http, $q, API) {
    function list(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/challenges/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listActive(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/challenges/active?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listArchive(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/challenges/ended?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listWinners(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/challenges/" + id + "/posts/shelfies/winners")
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/challenges/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/challenges", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/challenges/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/challenges/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/challenges/" + id + "/publish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      listActive: listActive,
      get: get,
      save: save,
      update: update,
      remove: remove,
      publish: publish,
      listArchive: listArchive,
      listWinners: listWinners
    };
  }
})();
